import $api from "@/zapi-frontend/shared/api/axios";
import { GetUsersSchema, TGetUsersResponse } from "./schemas";

export async function getOrganizationData(organizationId: number) {
  const response = await $api.get<TGetUsersResponse>(`/organizations/${organizationId}/users`);
  const parsed = GetUsersSchema.parse(response.data);
  return parsed;
}
